export const huntinggpsmapsData = {
    projectHeading: 'The Hunting GPS Maps Project',
    projectMainImage: {
        image: '/images/portfolio/hunting-gps-maps/hunting-gps-maps.jpg',
        alt: 'HuntingGPSMaps Portfolio Banner'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/hunting-gps-maps/chip-registration.png',
            image: '/images/portfolio/hunting-gps-maps/chip-registration-thumb.png',
            alt: 'GPS Chip Registration Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/hunting-home-mobile.png',
            image: '/images/portfolio/hunting-gps-maps/hunting-home-mobile-thumb.jpg',
            alt: 'Hunting GPS Maps Home Page - Mobile View'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/hunt-instructions.png',
            image: '/images/portfolio/hunting-gps-maps/hunt-instructions-thumb.png',
            alt: 'Mobile and GPS Instructions Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/hunt-redeem-page.png',
            image: '/images/portfolio/hunting-gps-maps/hunt-redeem-page-thumb.png',
            alt: 'Hunt Gift Card Redeem Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/pick-your-state.png',
            image: '/images/portfolio/hunting-gps-maps/pick-your-state-thumb.png',
            alt: 'Product Pick Your State Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/product-page.png',
            image: '/images/portfolio/hunting-gps-maps/product-page-thumb.jpg',
            alt: 'GPS and App Product Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/products-list.png',
            image: '/images/portfolio/hunting-gps-maps/products-list-thumb.jpg',
            alt: 'Products List Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/testimonials.png',
            image: '/images/portfolio/hunting-gps-maps/testimonials-thumb.jpg',
            alt: 'Product Testimonials Page'
        },
        {
            fullImage: '/images/portfolio/hunting-gps-maps/update.png',
            image: '/images/portfolio/hunting-gps-maps/update-thumb.png',
            alt: 'Product Update Page'
        }
    ],
    aboutHeading: 'About Hunting GPS Maps',
    aboutPortfolioText: [
        `HuntingGPSMaps was originally started by Eric Siegfried a few years before I joined the team in the winter of 2012. At the time, the company was still a startup, with me being it's 12th
         employee. The company was primarily focused on making digital hunting maps, with the goal of expanding the business to encompass all 50 states in the US. As time went on, the company developed Android
         and Apple apps as new revenue streams. As the company sought to expand into other markets, a rebranding occurred. This brought about the parent company, onXmaps (and temporariliy, sister ROAM).`,

        `HuntingGPSMaps was the primary bread-and-butter of the overall company. The website was part of a complex ecosystem which facilitated a Magento E-Commerce application which then fed user
         subscriptions into a database where the users can then access and interact with their maps. The website eventually grew to connect with it's parent (onXmaps) and it's sibling (ROAM), which
         provided avenues for government partnerships, user data management, and analytics.
         `
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of HuntingGPSMaps was to provide a way for users to purchase products and digital map subscriptions. It was also heavily utilized by marketing efforts to drive users to blogs and special
         events to increase traffic and online subscriptions.`
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Provide a way for customers to purchase physical and digital products`,
        `Allow the user to manage their digital subscription`,
        `Allow a way for the user to update their digital maps through an in-house update tool`,
        `Have a blog where content creators could create interesting content on a weekly basis`,
        `Create strong SEO to drive organic traffic to the site through search engines`,
        `Include tools to analyze user's flow and click through rates`,
        `Provide tutorial's to inform users how to troubleshoot and use their digital maps`,
    ],
    myRoleHeading: 'My Role On The Hunting GPS Maps Project',
    position: 'Lead Web Developer',
    company: 'onXmaps Inc.',
    timeWithCompany: '3 years, 5 months',
    myRoleText: [
        `My position within onXmaps started out as a Jr. Web Designer, with the primary objective of maintaining the sole sight, huntinggpsmaps.com and improving the SEO.
         At the time, we were working with a third party web developer, Inchoo, whom had built the site on the Magento E-Commerce Platform (Community Edition).
         Shortly after I joined, Inchoo ended their contract with onXmaps. I quickly picked up the responsibilities for the development and maintenance of the website, and eventually
         became the lead web developer for all of the web platforms.
        `,

        `Part of the responsibility of being the lead web developer was managing our projects through a 3rd party development shop, called Web Solutions.
         I would have meetings with the marketing team, lay out projects (diagrams, mockups, etc.) for the third party team, and then oversee the project.
         I would also be developing other features in the code, and then would code review the work Web Solutions had done. In addition, I had trained and was overseeing
         the work of Jr. Web Developer as well. Needless to say, I was involved every part of the process in the web system.
        `
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working on the Hunting GPS Maps Project',
    jobSummaryList: [
        `Build/Manage E-Commerce Database`,
        `Deploy seamless updates to website`,
        `Train Junior Developer`,
        `Meet with stakeholders to discuss new features`,
        `Build new features into the system`,
        `Sift through analytical data to determine bottlenecks for customers`,
        `Write requirements, design mockups, and facilitate projects with Third Party Web Development Contractors`,
        `Improve SEO on website (we were #1 for our targeted keywords in search engines)`,
        `Tie in third party features (UserVoice, MailChimp, etc.)`,
        `Design & lay out web pages. Often would generate content for these as well`,
        `Work closely with the marketing team for the implementation of marketing campaigns`,
        `Retrieve reports from the Database`,
        `Retrofit and Upgrade the system to be responsive and use modern technologies`,
        `Update SSL and Server Configurations through third party hosted dedicated server`,
        ],
    technologiesUsedIntro: `This section contains the technologies used for building the HuntingGPSMaps website.`,
    technologiesList: [
        `HTML5`,
        `JavaScript`,
        `CSS3`,
        `Magento 1.9`,
        `UserVoice`,
        `PHP`,
        `Git`,
        `Sass`,
        `jQuery`,
        `MailChimp Newsletter`,
        `Twitter Bootstrap`,
        `Google Analytics`,
        `Photoshop`,
        `Skrollr`,
        `Responsive Design`,
        `Red Hat Server`,
        `Illustrator`
    ]
}